import { useQuery } from 'hooks/useQuery';
import { getProviderById, listProviders } from 'lib/api/providers';
import { HookQueryOptions, queryKey } from './shared';

export const useProvidersQuery = (
  _payload?: void,
  options?: HookQueryOptions
) =>
  useQuery(queryKey('providers.list'), () => listProviders(), {
    skip: options?.skip,
  });

export const useProviderByIdQuery = (
  payload: { id: string },
  options?: HookQueryOptions
) =>
  useQuery(
    queryKey('providers.byId', payload),
    () => getProviderById(payload.id),
    { skip: options?.skip || !payload?.id }
  );
